import styled, { css } from '@benzinga/themetron';

interface ButtonProps {
  $isActive: boolean;
}

const ControlButton = styled.button<ButtonProps>`
  &:focus {
    outline: none;
  }

  &:hover {
    color: #008fd9;
    fill: #008fd9;
  }

  &:not(:first-child) {
    margin-left: 1em;
  }

  ${props =>
    props.$isActive &&
    css`
      border-bottom: 1px solid #008fd9;
      color: #008fd9;
      fill: #008fd9;
    `}
`;

export { ControlButton };
